module.exports = __webpack_public_path__ + "images/logo-reverse.svg";


//////////////////
// WEBPACK FOOTER
// ./images/logo-reverse.svg
// module id = 35
// module chunks = 0